// Central source of truth for post-login landing paths in RecruitLook Events.
//
// RLevents only has two audiences that sign in: organisation admins and event
// staff. Athletes, parents and coaches live on RecruitLook — anyone else lands
// on the "account not set up" page rather than being guessed into a dashboard.

export const ADMIN_LANDING_PATH = '/admin-dashboard';
export const STAFF_LANDING_PATH = '/staff-dashboard';
export const NO_ACCESS_LANDING_PATH = '/account-not-set-up';

export const ADMIN_ROLES = [
  'rlevents_super_admin',
  'super_admin',
  'admin',
  'rlevents_tenant_admin',
  'org_admin',
];

export const STAFF_ROLES = ['rlevents_tenant_staff', 'staff'];

export const DASHBOARD_PATH_BY_ROLE: Record<string, string> = {
  rlevents_super_admin: ADMIN_LANDING_PATH,
  super_admin: ADMIN_LANDING_PATH,
  admin: ADMIN_LANDING_PATH,
  rlevents_tenant_admin: ADMIN_LANDING_PATH,
  org_admin: ADMIN_LANDING_PATH,
  rlevents_tenant_staff: STAFF_LANDING_PATH,
  staff: STAFF_LANDING_PATH,
};

/**
 * Given one role slug, return its landing path.
 */
export function getDashboardPathForRole(role: string | null | undefined): string {
  if (!role) return NO_ACCESS_LANDING_PATH;
  return DASHBOARD_PATH_BY_ROLE[role] ?? NO_ACCESS_LANDING_PATH;
}

/**
 * Given a list of role slugs, pick the landing path. Admin beats staff;
 * anything unrecognised lands on the not-set-up page.
 */
export function getBestDashboardPath(roles: string[]): string {
  if (roles.some((r) => ADMIN_ROLES.includes(r))) return ADMIN_LANDING_PATH;
  if (roles.some((r) => STAFF_ROLES.includes(r))) return STAFF_LANDING_PATH;
  return NO_ACCESS_LANDING_PATH;
}
